<template>
    <div type="table" class="input shipperReview">
        <div class="input search">
            <label>
                <input type="search" :placeholder="input.searchPlaceholder" v-on:keyup="searchTable($event)" v-on:blur="searchTable($event)" />
            </label>
        </div>
        <table ref="table">
            <thead>
                <tr>
                    <td v-for="col in input.forms"
                        v-if="col.type != 'hidden'">
                        <div>
                            {{ col.name }}
                        </div>
                        <HelperBox v-if="col.helper" :text="col.helper"></HelperBox>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(sectionValue, index) in getNestedValue(formValue, input.value)"
                    :class="sectionValue.isDeleted ? 'deleted' : ''"
                    :data-search="sectionValue[input.forms[1].value].toLowerCase() + ' ' + sectionValue[input.forms[2].value].toLowerCase() + ' ' + sectionValue[input.forms[3].value].toLowerCase()"
                    v-if="!sectionValue[input.forms[6].value]">
                    <td v-for="sectionInput in input.forms"
                        v-if="sectionInput.type != 'hidden'">
                        <template v-if="sectionInput.type == 'label'">
                            <div>
                                {{ sectionValue[sectionInput.value] }}
                            </div>
                        </template>
                        <template v-else-if="sectionInput.type == 'button'">
                            <button v-on:click="onArrayItemDelete($event, sectionValue)">X</button>
                        </template>
                        <template v-else-if="sectionInput.type == 'number'">
                            <div type="number" class="input inline">
                                <label>
                                    <input type="text"
                                           pattern="[0-9]+([\.][0-9]{1,2})?"
                                           :placeholder="sectionInput.placeholder"
                                           :value="getNestedValue(sectionValue, sectionInput.value)"
                                           v-on:keyup="onInputValueChange($event, sectionInput.value, sectionValue)" />
                                    <small>{{ getInlineText(sectionInput.inline) }}</small>
                                </label>
                            </div>
                        </template>
                        <template v-else>
                            <InputField :input="sectionInput" :formValue="sectionValue"></InputField>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    import InputField from "./InputField.vue"
    import HelperBox from "../HelperBox.vue"

    export default {
        components: {
            InputField,
            HelperBox
        },
        name: "SectionTable",
        props: {
            input: {
                type: Object,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        methods: {
            onArrayItemDelete(e, item) {
                e.preventDefault();

                item.isDefault = item.isDeleted;
                item.isDeleted = !item.isDeleted;
            },
            searchTable(e) {
                let q = e.target.value.toLowerCase();

                this.$refs.table.querySelectorAll("tbody tr").forEach((row) => {
                    if (row.dataset.search.indexOf(q) == -1)
                        row.classList.add("hide")
                    else
                        row.classList.remove("hide")
                });
            },
            onInputValueChange(e, key, value) {
                value[key] = e.target.value;
                value.isDefault = false;
            },
            getInlineText(text) {
                if (text == "{currency}")
                    return this.$store.state.editor.version.data.studyCurrency;
                else if (text == "{format}")
                    return this.$store.state.editor.version.data.studyFormat;

                return text;
            }
        }
    }
</script>